// extracted by mini-css-extract-plugin
export default {"education":"EducationPage_education__DMzYb"};